import { ColorEnum } from '@/constants/color'
import CloseIcon from '@/features/ui/icons/components/CloseIcon'
import { FC } from 'react'
import Svg, { Circle, G } from 'react-native-svg'

const size = 40
const center = size / 2
const crossSize = 24
const crossPosition = center - crossSize / 2

const CrossInCircleIcon: FC = () => {
    return (
        <Svg height={size} width={size} style={{ alignItems: 'center', justifyContent: 'center' }}>
            <Circle
                fill={ColorEnum.Transparent}
                cx={center}
                cy={center}
                r={19}
                stroke={ColorEnum.RED_600}
                strokeWidth={2}
            />
            <G transform={`translate(${crossPosition}, ${crossPosition})`}>
                <CloseIcon height={crossSize} width={crossSize} fill={ColorEnum.RED_500} />
            </G>
        </Svg>
    )
}

export default CrossInCircleIcon
